import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from '@angular/core';
import { SliderOptions } from '../../../models/sections-model';
import { animate, animateChild, group, keyframes, query, style, transition, trigger } from '@angular/animations';

export const HEROES = [
  { id: 12, name: 'Dr. Nice' },
  { id: 13, name: 'Bombasto' },
  { id: 14, name: 'Celeritas' },
  { id: 15, name: 'Magneta' },
  { id: 16, name: 'RubberMan' },
  { id: 17, name: 'Dynama' },
  { id: 18, name: 'Dr. IQ' },
  { id: 19, name: 'Magma' },
  { id: 20, name: 'Tornado' }
];

@Component({
  selector: 'kw-tabbed-slider',
  templateUrl: './tabbed-slider.component.html',
  styleUrls: ['./tabbed-slider.component.scss'],
  animations: [
    trigger('query', [
      transition(':enter', [
        style({ height: 0 }),
        group([
          animate(500, style({ height: '*' })),
          query(':enter', [
            style({ opacity: 0, transform: 'scale(0)'}),
            animate(2000, style({ opacity: 1, transform: 'scale(1)' }))
          ]),
          query('.hero', [
            style({ transform: 'translateX(-100%)'}),
            animate('.7s 500ms ease-in', style({ transform: 'translateX(0)' }))
          ]),
        ]),
        query('@animateMe', animateChild()),
      ]),
      transition(':leave', [
        style({ height: '*' }),
        query('@animateMe', animateChild()),
        group([
          animate('500ms 500ms', style({ height: '0', padding: '0' })),
          query(':leave', [
            style({ opacity: 1, transform: 'scale(1)'}),
            animate('1s', style({ opacity: 0, transform: 'scale(0)' }))
          ]),
          query('.hero', [
            style({ transform: 'translateX(0)'}),
            animate('.7s ease-out', style({ transform: 'translateX(-100%)' }))
          ]),
        ]),
      ]),
    ]),
    trigger('animateMe', [
      transition('* <=> *', animate('500ms cubic-bezier(.68,-0.73,.26,1.65)', keyframes([
        style({ backgroundColor: 'transparent', color: '*', offset: 0 }),
        style({ backgroundColor: 'blue', color: 'white', offset: 0.2 }),
        style({ backgroundColor: 'transparent', color: '*', offset: 1 })
      ])))
    ]),
  ]
})
export class TabbedSliderComponent implements OnInit {
  @Input() data:SliderOptions;
  @Input() edit:boolean;
  tabs:any[];
  toggleDisabled = false;
  show = true;
  hero = HEROES[0];
  
  constructor(private cdref:ChangeDetectorRef,private zone:NgZone) { }

  ngOnInit(): void {
    console.log(this.data)
    /* this.tabs = this.data.tabs;
    if(this.tabs.length > 0){
      
    } */
  }

  toggleShow(){
    this.show = !this.show;
    this.cdref.detectChanges()
    /* this.zone.run(() => {
      this.show = !this.show;
    }) */
    
    console.log({show:this.show});
  }


}
